import React from 'react';
import { Helmet } from 'react-helmet';

// url is only emitted as canonical/og:url when the page passes one; pages
// without a stable public URL (admin, edit forms) must not claim the home
// page as their canonical — Google was flagging those as duplicates
const CustomHelmet = ({
  title = 'Active Projects',
  description = 'Equipping modern athletes with the gear and connections they need to succeed.',
  image = '',
  url = '',
}) => {
  const descInPlainText = description.replace(/(<([^>]+)>)/gi, '');
  const shortDescription = descInPlainText.substring(0, 160);

  const { REACT_APP_AWS_S3 } = process.env;
  const imageUri = image ? REACT_APP_AWS_S3 + '/' + image : '';

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={shortDescription} />
      {imageUri && <meta name="image" content={imageUri} />}
      {url && <link rel="canonical" href={url} />}
      {url && <meta property="og:url" content={url} />}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={shortDescription} />
      {imageUri && <meta property="og:image" content={imageUri} />}
    </Helmet>
  );
};

export default CustomHelmet;
